import cx from 'classnames'
import Styles from '../PropertyForm.module.scss'

const Checkbox = () => {
  return (
    <div className={cx(Styles.textSubsection, Styles.defaultInputWrapper)}>
      <div className={Styles.sectionSubheader}>A property that can be checked or unchecked.</div>
    </div>
  )
}

export default Checkbox
